/* tslint:disable */

/**
 */
export class MeshPosition {
    ID_MESH_POSITION?: number;
    ID_PRODUCT_ELMT?: number;
    MESH_AXIS?: number;
    MESH_ORDER?: number;
    MESH_AXIS_POS?: number;
    ID_STUDY?: number;
    meshAxisPosValue?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/mesh-position.ts